module.exports = __webpack_public_path__ + "img/dr_9.bea70473.png";